import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";


@Options({
    template: false,
    el: ".js-sidebar-newsletter-wrap",
    ui: {
        sidebarNewsletterForm: ".js-form-newsletter-wrap",
        submitBtn: ".js-submit-btn",
        sidebarHeader: ".js-sidebar-header",
        sidebarBody: ".js-sidebar-body"
    }
})
export default class ViewController extends Marionette.View<Backbone.Model>{

    constructor() {
        super();
    }

    // --------------------------------
    // events
    // --------------------------------

    @on("submit @ui.sidebarNewsletterForm")
    onSidebarNewsletterFormSubmit(JQueryEventObject: any) {
        const submitURL = this.getSubmitURL();

        JQueryEventObject.preventDefault();
        this.submitFormAjax(submitURL);
    }

    // --------------------------------
    // functions
    // --------------------------------

    onRender() {
        console.log("form sidebar newsletter signup rendered");
    }

    submitFormAjax(submitURL: string) {
        // ** IMPORTANT: form elements MUST have a `name` attribute for serialize to work
        let formData = this.ui.sidebarNewsletterForm.serialize();
        let successMsg = this.getSuccessMsgFromDataAttr(this.ui.sidebarNewsletterForm);
        let errorMsg = this.getErrorMsgFromDataAttr(this.ui.sidebarNewsletterForm);

        // submit form data
        // ** $.post parameters: (url, data, callback)
        // ** MUST use arrow syntax here instead `function()`
        // to maintain `this` from code that contains arrow
        // function (aka "lexical scoping")
        $.post(submitURL, formData)
        .done( () => {
            this.showSuccessScreen(successMsg);
        }).fail( () => {
            this.showErrorScreen(errorMsg);
        }).always( () => {
            // stub
        });
    }

    getSubmitURL() {
        return this.ui.sidebarNewsletterForm.data("submit-url");
    }

    getSuccessMsgFromDataAttr($formElement: any) {
        return $formElement.data("success-msg");
    }

    getErrorMsgFromDataAttr($formElement: any) {
        return $formElement.data("error-msg");
    }

    showSuccessScreen(successMsg: string) {
        this.ui.sidebarNewsletterForm.hide(500); // hide, form when successful, 500 ms
        this.ui.sidebarBody.text(successMsg);
    }

    showErrorScreen(errorMsg: string) {
        this.ui.sidebarBody.addClass("has-error"); // change text to red
        this.ui.sidebarBody.text(errorMsg);
    }
}



// WEBPACK FOOTER //
// ./django/project/@static/@modules/form-sidebar-newsletter-signup/controller.ts